import { render, staticRenderFns } from "./initial-organization-activation-modal.vue?vue&type=template&id=a10d3d46&scoped=true"
import script from "./initial-organization-activation-modal.vue?vue&type=script&lang=js"
export * from "./initial-organization-activation-modal.vue?vue&type=script&lang=js"
import style0 from "./initial-organization-activation-modal.vue?vue&type=style&index=0&id=a10d3d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10d3d46",
  null
  
)

export default component.exports